import { TextField } from "@mui/material";

export function FormTextField({ formik, name, value, label, size = "large", margin = 'dense', ...props }) {    
    return (
        <TextField
            size={size}
            fullWidth
            margin={margin}
            id={name}
            name={name}
            label={label}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            {...props}
        />
    )
}